<template>
  <!-- <div v-if="type[0].codename === 'shortLongStay'" class="mini-card"> -->
  <div class="mini-card" :class="{fit : fit}">
    <div class="mini-card__row">
      <div class="np--all">
        <div ref="slider" v-swiper:mySwiper="swiperOption" class="simple-slider">
          <div class="swiper-wrapper">
            <div v-for="(image, index) in images" :key="index" class="swiper-slide simple-slider__item">
              <KenticoResponsiveImage :alt="image.description" :src="image.url" class="simple-slider__image" :sizes="imageSizes" />
            </div>
          </div>
          <div slot="button-next" class="swiper-button swiper-button-next"><Chevron /></div>
          <div slot="button-prev" class="swiper-button swiper-button-prev"><Chevron /></div>
          <div class="mini-card__control">
            <ul class="mini-card__progress">
              <li
                  v-for="(dot, index) in images"
                  :key="index"
                  :class="{ active: currentSection >= index + 1 }"
                  class="mini-card__progress-item"
                  @click="goToSection(index + 1)"
              >
                <button class="mini-card__progress-dot">Go to slide {{ index + 1 }}</button>
                <span v-if="index + 1 > 1" class="mini-card__progress-bar">
                  <div class="mini-card__progress-bar-inner" />
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="np--all"><slot name="details" /></div>
    </div>
  </div>
</template>

<script>
import getStatic from '~/utils/get-static';
import { BREAKPOINTS, BREAKPOINT_LG } from '~/utils/constants';
import pascalCase from 'pascal-case';
import { viewedCarousel } from '~/utils/gtm-events.js';

export default {
  props: {
    room: { type: String, default: '' },
    fit: { type: Boolean, default: false },
    images: {
      type: Array,
      required: true,
      default() {
        return [
          {
            url: getStatic('/images/content/what-we-do/people-cycling.png'),
            description: 'group of people cycling',
          },
        ];
      },
    },
    type: { type: Array, default() {
      return [{ codename: '', name: '' }];
    } },
    bookingType: { type: String, default: '' },
  },
  data() {
    return {
      currentSection: 1,
      swiperOption: {
        slidesPerView: 1,
        loop: true,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        on: {
          slideChange: () => {
            this.currentSection = this.$refs.slider ? this.$refs.slider.swiper.realIndex + 1 : 1;

            // if slide has a name, use that, otherwise just use 'image{index}' as name
            const imageTitle = this.images[this.currentSection - 1].name ? this.images[this.currentSection - 1].name : `image${this.currentSection}`;
            const pascalRoom = pascalCase(this.room.toLowerCase());
            viewedCarousel(this.$gtm, pascalRoom, imageTitle, this.currentSection, this.images.length );
          },
        },
      },
      imageSizes: {
        default: [900, 750],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 1200, height: 1000 },
        ],
      },
    };
  },
  methods: {
    spotClasses(spot) {
      const spotClass = `building-plan__spot--${spot}`;
      if (this.currentSection === spot) {
        return `active ${spotClass}`;
      }
      return spotClass;
    },
    goToSection(section) {
      this.mySwiper.slideTo(section);
    },
  },
};
</script>

<style lang="scss">
@import '~/node_modules/swiper/dist/css/swiper.css';
@import '~/assets/scss/atomic/components/_mini-card.scss';
</style>
